import { Subscription } from 'rxjs';
import { AppConfig } from '../../app.config';
import { DashboardEventService } from '../../dashboard/dashboard-event.service';
import { Component, OnInit, Output, AfterViewInit, OnDestroy, Input } from '@angular/core';
import { UserProfileOperations } from '@liquitics/transaction';

@Component({
    selector: 'app-home-sidebar-operations',
    templateUrl: './sidebar-operations.component.html',
    styleUrls: ['./../home.sidebar.component.scss', './sidebar-operations.component.scss']
})
export class SidebarOperationsComponent implements OnInit, OnDestroy, AfterViewInit {
    @Input()
    profileType: string;
    subscription: Subscription;
    viewMode: string;

    constructor(
        private dashboardEventService: DashboardEventService,
        private appConfig: AppConfig) {
    }

    ngOnInit() {
        const operationsProfile: UserProfileOperations = this.appConfig.activeUserProfile as UserProfileOperations;
        this.viewMode = 'RECORD_MODIFICATION';
        this.dashboardEventService.viewModeSelectionSubject.next(this.viewMode);
    }


    ngOnDestroy() {
        if (this.subscription) {
            this.subscription.unsubscribe();
        }
    }

    ngAfterViewInit() {
    }

    initializeSideBar() {
    }

    onViewModeChange(event) {
        this.viewMode = event.value;
        this.dashboardEventService.viewModeSelectionSubject.next(event.value);
    }
}
